export default __webpack_public_path__ + "static/media/pinOutline.42bcc95f.svg";